module.exports = __webpack_public_path__ + "static/assets/a2d061492bb48170f51a2f436b866a80.png";